import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./config/i18n"; // Initialize i18n
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import WelcomePage from "./pages/WelcomePage";
import SignInPage from "./pages/SignInPage";
import SignOutPage from "./pages/SignOutPage";
import SignUpPage from "./pages/SignUpPage";
import CreateHabitPage from "./pages/CreateHabitPage";
import HabitListPage from "./pages/HabitListPage";
import HabitEditPage from "./pages/HabitEditPage";
import PricingPage from "./pages/PricingPage";
import UpgradePlanPage from "./pages/UpgradePlanPage";
import SettingsPage from "./pages/SettingsPage";
import StreakStatisticsPage from "./pages/StreakStatisticsPage";

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          {/* Page d'accueil - redirige vers /habits si l'utilisateur est connecté */}
          <Route
            path="/"
            element={
              <ProtectedRoute requireAuth={false} redirectTo="/habits">
                <WelcomePage />
              </ProtectedRoute>
            }
          />

          {/* Pages d'authentification - redirigent vers /habits si l'utilisateur est déjà connecté */}
          <Route
            path="/auth/signin"
            element={
              <ProtectedRoute requireAuth={false} redirectTo="/habits">
                <SignInPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/auth/signup"
            element={
              <ProtectedRoute requireAuth={false} redirectTo="/habits">
                <SignUpPage />
              </ProtectedRoute>
            }
          />
          <Route path="/auth/signout" element={<SignOutPage />} />

          {/* Pages protégées - nécessitent une authentification */}
          <Route
            path="/habits/create"
            element={
              <ProtectedRoute requireAuth={true} redirectTo="/auth/signin">
                <CreateHabitPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/habits"
            element={
              <ProtectedRoute requireAuth={true} redirectTo="/auth/signin">
                <HabitListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/habits/edit/:habitId"
            element={
              <ProtectedRoute requireAuth={true} redirectTo="/auth/signin">
                <HabitEditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/streaks"
            element={
              <ProtectedRoute requireAuth={true} redirectTo="/auth/signin">
                <StreakStatisticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upgrade-plan"
            element={
              <ProtectedRoute requireAuth={true} redirectTo="/auth/signin">
                <UpgradePlanPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute requireAuth={true} redirectTo="/auth/signin">
                <SettingsPage />
              </ProtectedRoute>
            }
          />

          {/* Pages publiques */}
          <Route path="/pricing" element={<PricingPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
